import { render, staticRenderFns } from "./StaffListView.vue?vue&type=template&id=a9da0e0c&"
import script from "./StaffListView.vue?vue&type=script&lang=js&"
export * from "./StaffListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports